import { computed, ref } from 'vue'
import type { ComputedRef, InjectionKey } from 'vue'

export const WTooltipSuppressLabelKey: InjectionKey<ComputedRef<boolean>> = Symbol('WTooltipSuppressLabelKey')

export const LABEL_TOOLTIP_SKIP_OPEN_DELAY = 1
export const LABEL_TOOLTIP_SKIP_DELAY_TIMEOUT = 400

const labelTooltipInstantPhase = ref(false)
let currentLabelTooltipId: symbol | undefined
let labelTooltipDelayResetTimer: ReturnType<typeof setTimeout> | undefined
const labelTooltipCloseHandlers = new Map<symbol, () => void>()

const clearLabelTooltipDelayResetTimer = (): void => {
  if (labelTooltipDelayResetTimer === undefined) return

  clearTimeout(labelTooltipDelayResetTimer)
  labelTooltipDelayResetTimer = undefined
}

export const labelTooltipDelayGroup = {
  isInstantPhase: computed(() => labelTooltipInstantPhase.value),
  skipOpenDelay: LABEL_TOOLTIP_SKIP_OPEN_DELAY,
  timeout: LABEL_TOOLTIP_SKIP_DELAY_TIMEOUT,
  register(id: symbol, closeHandler: () => void): void {
    labelTooltipCloseHandlers.set(id, closeHandler)
  },
  unregister(id: symbol): void {
    labelTooltipCloseHandlers.delete(id)
  },
  closeCurrentBeforeOpen(id: symbol): void {
    if (currentLabelTooltipId === undefined || currentLabelTooltipId === id) return

    labelTooltipCloseHandlers.get(currentLabelTooltipId)?.()
  },
  markOpened(id: symbol): void {
    const previousId = currentLabelTooltipId
    if (previousId !== undefined && previousId !== id) {
      labelTooltipCloseHandlers.get(previousId)?.()
    }

    clearLabelTooltipDelayResetTimer()
    currentLabelTooltipId = id
    labelTooltipInstantPhase.value = true
  },
  markClosed(id: symbol): void {
    if (currentLabelTooltipId !== id) return

    clearLabelTooltipDelayResetTimer()
    labelTooltipDelayResetTimer = setTimeout(() => {
      if (currentLabelTooltipId === id) {
        currentLabelTooltipId = undefined
        labelTooltipInstantPhase.value = false
      }
      labelTooltipDelayResetTimer = undefined
    }, LABEL_TOOLTIP_SKIP_DELAY_TIMEOUT)
  },
  reset(): void {
    clearLabelTooltipDelayResetTimer()
    currentLabelTooltipId = undefined
    labelTooltipInstantPhase.value = false
  },
}
